import React, { useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';
import { stopPropagation } from '../../utils/helpers';
import Portal from '../Portal';
import { StyledModal, StyledModalBodyWrapper, StyledModalBody } from './styled';

const Modal = ({ children, open, disableEscapeKeyDown, onBackdropClick, onEscapeKeyDown, onClose }) => {
    const escFunction = useCallback((event) => {
        if (!disableEscapeKeyDown && event.keyCode === 27) {
            onEscapeKeyDown && onEscapeKeyDown();
        }
    }, [disableEscapeKeyDown, onEscapeKeyDown]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);

        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    useEffect(() => {
        if (!open) {
            onClose && onClose();
            document.body.style = '';
        } else {
            document.body.style = 'overflow: hidden'
        }
    }, [open, onClose]);

    useEffect(() => {
        if(open) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'initial';
        }
        return () => {
            document.body.style.overflow = 'initial';
        }
    }, [open])

    return (
        <Portal
            id='modal-root'
        >
            {
                open &&
                <StyledModal
                    onClick={onBackdropClick}
                >
                    <StyledModalBodyWrapper>
                        <StyledModalBody onClick={stopPropagation}>
                            {children}
                        </StyledModalBody>
                    </StyledModalBodyWrapper>
                </StyledModal>
            }
        </Portal>
    );
};

Modal.propTypes = {
    children: PropTypes.node,
    open: PropTypes.bool,
    disableEscapeKeyDown: PropTypes.bool,
    onBackdropClick: PropTypes.func,
    onEscapeKeyDown: PropTypes.func,
    onClose: PropTypes.func

};

Modal.defaultProps = {
    open: false,
    disableEscapeKeyDown: false,
    onBackdropClick: undefined,
    onEscapeKeyDown: undefined,
    onClose: undefined
};

export default React.memo(Modal);